<template>
  <!-- <form action="" ref="form" lazy-validation @submit="onSave" class="pt-0"> -->
  <v-form v-model="valid" action="" ref="form" lazy-validation class="pt-0">
    <v-card>
      <v-card-title primary-title>
        <h3 class="headline mb-0">國健署表單</h3>
      </v-card-title>
      <v-tabs
        v-model="tab"
        bg-color="primary"
      >
        <v-tab >區塊1</v-tab>
        <v-tab >區塊2(Findings)</v-tab>
      </v-tabs>
      <v-card-text>
        <v-tabs-items v-model="tab">
          <v-tab-item >
            <v-card flat>
              <v-card-text>
                <v-layout row wrap>
                  <v-flex xs12 sm6 v-for="(field, index) in section1" :key="index">
                    <v-select
                      v-if="field.type === 'select'"
                      :label="field.label"
                      :items="field.options"
                      v-model="formDetail[field.column]"
                      :readonly="field.readonly ? field.readonly : false"
                      :multiple="field.multiple ? field.multiple : false"
                      :required="field.required ? field.required() : false"
                      :name="field.column"
                      :rules="field.rules || []"
                    ></v-select>
                    <v-text-field
                      v-else
                      :label="field.label"
                      :value="field.value"
                      :readonly="field.readonly ? field.readonly : false"
                      :required="field.required ? field.required() : false"
                      :name="field.column"
                      :rules="field.rules || []"
                    ></v-text-field>
                    
                  </v-flex>
                </v-layout>

                <!-- 2：有條件的下拉選單 -->
                <v-layout row wrap>
                  <v-flex 
                    xs12 
                    sm6 
                    v-for="(item, idx) in section2" 
                    :key="idx"
                    v-if="!item?.depend || item?.depend()"
                  >
                    <v-text-field
                      v-if="item.type === 'input'"
                      :label="item.label"
                      v-model="formDetail[item.column]"
                      :readonly="item.readonly ? item.readonly : false"
                      :type="item.dataType ? item.dataType : 'text'"
                      :maxlength="item.maxlength ? item.maxlength : undefined"
                      :required="item.required ? item.required() : false"
                      :name="item.column"
                      :rules="item.rules || []"
                    ></v-text-field>
                    <v-select
                      v-else
                      :label="item.label"
                      :items="item.options"
                      v-model="formDetail[item.column]"
                      :readonly="item.readonly ? item.readonly : false"
                      :multiple="item.multiple ? item.multiple : false"
                      :required="item.required ? item.required() : false"
                      :name="item.column"
                      :rules="item.rules || []"
                    ></v-select>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item >
            <v-card flat>
              <v-card-text>
                <v-tabs
                  v-model="tabBlock2"
                  bg-color="primary"
                  show-arrows
                  class="scrollable-tabs"
                >
                  <v-tab v-for="(finding, key) in findingDatas" :key="`block2tab_${key}`">
                    <span>{{ finding.findingEachName }}-{{ finding.findingEachSerial }}</span>
                  </v-tab>
                </v-tabs>
                <v-tabs-items v-model="tabBlock2">
                  <v-tab-item v-for="(finding, key) in findingDatas" :key="`block2_${key}`">
                    <v-card flat>
                      <v-card-text v-if="findingDatas[key]">
                        <v-layout row wrap>
                          <v-flex 
                            xs12 
                            sm6 
                            v-for="(field, index) in section3[key]" 
                            :key="`block2_${key}_${index}`"
                            v-if="!field?.depend || field?.depend()"
                          >
                            <v-select
                              v-if="field.type === 'select'"
                              :label="field.label"
                              :items="field.options"
                              v-model="findingDatas[key][field.column]"
                              :readonly="field.readonly ? field.readonly : false"
                              :multiple="field.multiple ? field.multiple : false"
                              :required="field.required && field.required(findingDatas[key])"
                              :name="field.column+index"
                              :rules="field.checkC2C3D1 ? dynamicC2C3D1Rules(findingDatas[key], field.ruleConfig) : field.rules || []"
                            ></v-select>
                            <v-text-field
                              v-else
                              :label="field.label"
                              v-model="findingDatas[key][field.column]"
                              :readonly="field.readonly ? field.readonly : false"
                              :required="field.required && field.required(findingDatas[key])"
                              :type="field.dataType ? field.dataType : 'text'"
                              :max="field.max ? field.max : undefined"
                              :min="field.min ? field.min : undefined"
                              :name="field.column+index"
                              :rules="field.dynamicRules 
                                ? field.dynamicRules(findingDatas[key]) 
                                : field.checkC2C3D1 
                                  ? dynamicC2C3D1Rules(findingDatas[key], field.ruleConfig) 
                                  : field.rules || []"
                            ></v-text-field>
                          </v-flex>
                        </v-layout>
                      </v-card-text>
                    </v-card>
                  </v-tab-item>
                </v-tabs-items>
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs-items>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn type="button" color="green" @click="onSave">SAVE</v-btn>
      </v-card-actions>
    </v-card>
  <!-- </form> -->
  </v-form>
</template>

<script>
import FindingItems from './findingItems'
import md5 from 'md5'
import { 
  handleIshareDetailData,
  handleIshareLesionData,
  importIshareDataFromDB,
  findingBody, 
  complicationOptions, 
  indicationOptions,
  indication1Options,
  verify1Options,
  insertionLevelMap,
  insertionLevelOptions,
  premedication1aOptions,
  premedication1bOptions,
  premedication2bOptions,
  colonPreparationOptions,
  preparationTimeOptions,
  preparationConditionOptions,
  antiPlateletOptions,
  antiPlatelet1Options,
  findingCodeOptions,
  locationOptions,
  samplingOptions,
  samrOptions,
  lesionAOptions,
  lesionBOptions,
  lesionCOptions,
  lesionC1Options,
  lesionC2Options,
  lesionC3Options,
  lesionDOptions,
  lesionD1Options,
  lesionD2Options,
  lesionEOptions,
  lesionFOptions,
  polypOptions,
  saveIshareData
} from '@/services/iShareHub'
import { readonly } from 'vue';
export default {
  components: {
    FindingItems,
  },
  props: {
    patient: {
      type: Object,
      required: true,
    },
    examination: {
      type: Object,
      required: true,
    },
    findings: {
      type: Array,
      required: true,
    },
    ishareData: {
      type: Object,
      required: true,
    },
    dbIshareData: {
      type: Object,
      required: true,
      default: () => ({
        detail: {},
        lesion: [],
        md5_code: ''
      })
    },
  },
  computed:{
    age(){
      const examDate = this.examination.date
      const birthday = this.patient.birthday
      const examDateObj = new Date(examDate)
      const birthdayObj = new Date(birthday)
      const age = examDateObj.getFullYear() - birthdayObj.getFullYear()
      return age
    },
    patientId(){
      return String(this.patient.no)
    } 
  },
  async mounted(){
    await this.initialSectio3Data()
    this.formDetail = handleIshareDetailData(this.ishareData, this.patient, this.examination)
    if(this.dbIshareData.detail && Object.keys(this.dbIshareData.detail).length > 0){
      this.importDbData()
    }
    this.section1 = [
      { key: '1', label: '檢查醫療院所代碼', value: 'H000001', readonly: true, required: ()=> true, rules: [v => !!v || '必填'] },
      // "至少為10碼
      //大寫半型英數字元"
      { key: '2', label: '身分證或護照號碼', value: this.formDetail.idno, readonly: true, required: () => true, rules: [v => !!v || '必填', v => v.length >= 10 || '至少為10碼', v => !!v.match(/^[A-Z0-9]+$/i) || '大寫半型英數字元'] },
      { key: '3', label: '性別', value: this.formDetail.patient_sex === "1" ? '男' : '女', readonly: true, required: () => true, rules: [v => !!v || '必填'] },
      { key: '4', label: '姓名', value: this.formDetail.patient_name, readonly: true, required: () => true, rules: [v => !!v || '必填'] },
      { key: '5', label: '出生日期', value: this.formDetail.patient_birth, readonly: true, required: () => true, rules: [v => !!v || '必填'] },
      { key: '6', label: '年齡', value: this.formDetail.patient_age, readonly: true, required: () => true, rules: [v => !!v || '必填'] },
      // 不能有非英數字字元
      { key: '8', label: '病歷號碼', value: this.patientId, required: () => true, readonly: true, rules: [v => !!v || '必填', v => !!v.match(/^[A-Z0-9]+$/i) || '不能有非英數字字元'] },
      { key: '9', label: '大腸鏡檢日期', value: this.formDetail.exam_date ,readonly: true, required: () => true, rules: [v => !!v || '必填'] },
      { key: '12a', label: '時間登錄(檢查開始時間)', value: this.formDetail.StartTime, readonly: true, rules: [v => !!v || '必填'] },
      { key: '12b', label: '時間登錄(檢查至盲腸時間)', value: this.formDetail.ReachCecumAt, readonly: true, rules: [v => !!v || '必填'] },
      { key: '12c', label: '時間登錄(檢查結束時間)', value: this.formDetail.EndTime, readonly: true, rules: [v => !!v || '必填'] },
      { key: '13', label: '大腸鏡伸入最深位置', value: this.formDetail.insertion_level, readonly: true, type: 'select', options: insertionLevelOptions, column: 'insertion_level', required: () => true, rules: [v => !!v || '必填'] },
    ]
    this.section2 = [
      { key: '7a', label: '適應症', type: 'select', column: 'indication', options: indicationOptions, required: () => true, readonly: true, rules: [v => !!v || '必填'] },
      { key: '7b', label: '適應症-其他1(可複選)', column: 'indication1', options: indication1Options, type: 'select', depend: () => this.formDetail.indication === '9', multiple: true, required: () => this.formDetail.indication === '9', readonly: true },
      { key: '7c', label: '適應症-其他2', column: 'indication2', type: 'input', depend: () => this.formDetail.indication === '9' && this.formDetail.indication1.join('').includes('g'), required: () => this.formDetail.indication === '9' && this.formDetail.indication1.join('').includes('g') },
      { key: '10', label: '檢查醫師姓名', column: 'verify', type: 'input', readonly: true, required: () => true, rules: [v => !!v || '必填'] },
      { key: '11a', label: '檢查醫師科別', column: 'verify1', type: 'select', options: verify1Options, required: () => true, readonly: true, rules: [v => !!v || '必填'] },
      { key: '11b', label: '檢查醫師科別-其他科別', column: 'verify2', type: 'input' ,depend: () => this.formDetail.verify1 === '9', required: () => this.formDetail.verify1 === '9'},
      { key: '14a', label: '檢查前用藥-止痙攣藥物', column: 'premedication1a', type: 'select', options: premedication1aOptions, required: () => true, readonly: true, rules: [v => !!v || '必填'] },
      { key: '14b', label: '檢查前用藥-止痙攣藥物原因', column: 'premedication1b', type: 'select', options: premedication1bOptions, depend: () => this.formDetail.premedication1a !== '1', readonly: true },
      { key: '15a', label: '檢查前用藥-止痛鎮靜藥物', column: 'premedication2a', type: 'select', options: premedication1aOptions, required: () => true, readonly: true, rules: [v => !!v || '必填'] },
      { key: '15b', label: '檢查前用藥(可複選)-止痛鎮靜藥物項目', column: 'premedication2b', type: 'select', options: premedication2bOptions, depend: () => this.formDetail.premedication2a === '1', multiple: true, readonly: true },
      { key: '16a', label: '清腸用藥 (可複選)', column: 'colon_preparation', type: 'select', options: colonPreparationOptions, multiple: true, required: () => true, readonly: true, rules: [v => v.length > 0 || '必填'] },
      { key: '16b', label: '清腸用藥-其他', column: 'colon_preparation1', type: 'input', depend: () => this.formDetail.colon_preparation.join('').includes('9'), required: () => this.formDetail.colon_preparation.join('').includes('9'), rules: [v => !!v || '必填'] },
      { key: '17', label: '清腸給藥時間', column: 'preparation_time', type: 'select', options: preparationTimeOptions, readonly: true },
      { key: '18', label: '清腸程度', column: 'preparation_condition', type: 'select', options: preparationConditionOptions, required: () => true, readonly: true, rules: [v => !!v || '必填'] },
      { key: '19a', label: '抗凝血藥物', column: 'anti_platelet', type: 'select', options: antiPlateletOptions, readonly: true },
      // { key: '19b', label: '抗凝血藥物項目 (可複選)', column: 'anti_platelet1', type: 'select', options: antiPlatelet1Options, depend: () => this.formDetail.anti_platelet !== '0', multiple: true, readonly: true, rules: [v => v.length > 0 && v.length <= 3 || '請選擇項目，最多只能選3項'] },
      { key: '19b', label: '抗凝血藥物項目 (可複選)', column: 'anti_platelet1', type: 'select', options: antiPlatelet1Options, depend: () => this.formDetail.anti_platelet !== '0', multiple: true, readonly: true, rules: [] },
      // 當抗凝血藥物項目Anti_platelet1無值，此欄不得有值
      { 
        key: '19c', label: '第一種抗凝血藥物停藥天數', type: 'input', column: 'days1', 
        depend: ()=>{return this.formDetail.anti_platelet !== '0'}, 
        maxlength: 2, readonly: true,  
        rules: this.formDetail.anti_platelet1.length < 1 ? [v => v.length === 0 || '當抗凝血藥物項目無值，此欄不得有值'] : []
      },
      { 
        key: '19d', label: '第二種抗凝血藥物停藥天數', type: 'input', column: 'days2', 
        depend: ()=>{return this.formDetail.anti_platelet !== '0'}, 
        maxlength: 2, readonly: true,
        rules: this.formDetail.anti_platelet1.length < 1 ? [v => v.length === 0 || '當抗凝血藥物項目無值，此欄不得有值'] : []
      },
      { 
        key: '19e', label: '第三種抗凝血藥物停藥天數', type: 'input', column: 'days3', 
        depend: ()=>{return this.formDetail.anti_platelet !== '0'}, 
        maxlength: 2, readonly: true,
        rules: this.formDetail.anti_platelet1.length < 1 ? [v => v.length === 0 || '當抗凝血藥物項目無值，此欄不得有值'] : []
      },
      { key: '20a', label: '鏡檢後併發症 (可複選)', column: 'Complication', type: 'select', options: complicationOptions, multiple: true, required: () => true, readonly: true, rules: [v => !!v || '必填'] },
      { key: '20b', label: '鏡檢後併發症-其他', column: 'Complication1', type: 'input', depend: () => this.formDetail.Complication.join('').includes('9'), required: () => this.formDetail.Complication.join('').includes('9'), rules: [v => !!v || '必填'] },
      { key: '21', label: '檢體總數', column: 'specimen_count', type: 'input', required: () => true, readonly: true, rules: [v => String(v).length > 0 || '必填'] },
    ]
  }, 
  data() {
    return {
      reportCategory: 'summary',
      tab: 0,
      tabBlock2: 0,
      detailId: null,
      findingDatas: [],
      formDetail: {
        // ...detailBody,
        // patient_name: this.patient.name,
        // patient_birth: this.patient.birthday,
        // patient_sex: this.patient.gender,
        // patient_age: this.age,
        // chartno: this.examination.accNo,
        // exam_date: this.examination.date,
        // verify: '醫生A',
        // verify1: '1',
        // hosp_id: 'H000001',
        // idno: this.patient.nationId,
        // indication: this.examination.indication.length > 0 ? this.examination.indication[0] : '2',
      },
      // 靜態不可調整區塊
      section1: [],
      // 非Finding 可調整區塊
      section2: [],
      // Finding 可調整區塊
      section3: [],
      valid: true,
    }
  },
  methods: {
    lesionSubtypeExceptionList(data){
      const exceptionList = []
      if(data.finding_code !== 'C' && data.finding_code !== 'D'){
        return false
      }
      switch(data.finding_code){
        case 'C':
          if(data.findingId === '9'){
            return true
          }
          else{
            return false
          }
        case 'D':
          switch(data.findingId){
            case '17':
            case '18':
            case '19':
            case '20':
            case '57':
            case '41':
            case '42':
            case '44':
            case '45':
            case '46':
            case '47':
              return true
            default:
              return false
          }
        default:
          return false
      }

    },
    isC2C3D1(data){
      if(!['C','D'].includes(data.finding_code)){
        return false
      }
      if(data.finding_code === 'C' && !['2','3'].includes(data.lesion_type)){
        return false
      }
      if(data.finding_code === 'D' && data.lesion_type !== '1'){
        return false
      }
      return true
    },
    dynamicC2C3D1Rules(data, {dataType = 'string', errorText = '必填', exceptionFindingIds = [], limitLength = 0, extraRule = null} = {}){
      let rules = []
      if(!this.isC2C3D1(data)){
        return rules
      }
      if (!exceptionFindingIds.includes(data.findingId)){
        return rules
      }
      if(dataType === 'array'){
        if(limitLength > 0){
          rules.push(v => v.length === limitLength || `${errorText} (最多${limitLength}個)`)
        }else{
          rules.push(v => v.length > 0 || errorText)
        }
      } else if(extraRule){
        if(extraRule.method === 'equals' && data[extraRule.column] === extraRule.value){
          rules.push(v => !!v || errorText)
        }
      } else {
        rules.push(v => !!v || errorText)
      }
      return rules
    },
    addSection3Data(index){
      this.section3.push([
        { key: '22a', label: '臨床診斷(內視鏡診斷)結果', type: 'select', options: findingCodeOptions, column: 'finding_code', required: () => true, readonly: true, rules: [v => !!v || '必填']},
        { key: '22b', label: '診斷-正常', type: 'select', options: lesionAOptions, column: 'lesion_type', depend: () => this.findingDatas[index].finding_code === 'A', required: () => true, readonly: true, rules: [v => !!v || '必填'] },
        { key: '22c', label: '診斷-痔瘡', type: 'select', options: lesionBOptions, column: 'lesion_type', depend: () => this.findingDatas[index].finding_code === 'B', 
          required: () => true, 
          readonly: this.findingDatas[index].lesion_type === '' ? false : true, 
          rules: [v => !!v || '必填'] 
        },
        { key: '22d', label: '診斷-瘜肉', type: 'select', options: lesionCOptions, 
          column: 'lesion_type', 
          depend: () => this.findingDatas[index].finding_code === 'C', 
          required: () => true, 
          readonly: this.findingDatas[index].lesion_type === '' ? false : true, 
          rules: [v => !!v || '必填'] 
        },
        { key: '22e', label: '診斷-瘜肉且為增生性瘜肉', type: 'select', options: lesionC1Options, column: 'lesion_subtype', 
          depend: () => this.findingDatas[index].finding_code === 'C' && this.findingDatas[index].lesion_type === '1', required: () => true, 
          rules: [v => !!v || '必填'] },
        { key: '22f', label: '診斷-瘜肉且為腺瘤', type: 'select', options: lesionC2Options, column: 'lesion_subtype', 
          depend: () => this.findingDatas[index].finding_code === 'C' && this.findingDatas[index].lesion_type === '2', 
          required: () => true, rules: [v => !!v || '必填'] },
        { key: '22g', label: '診斷-瘜肉且為其他瘜肉', type: 'select', options: lesionC3Options, column: 'lesion_subtype', depend: () => this.findingDatas[index].finding_code === 'C' && this.findingDatas[index].lesion_type === '3', required: () => true, rules: [v => !!v || '必填'] },
        { key: '22h', label: '診斷-腫瘤', type: 'select', options: lesionDOptions, column: 'lesion_type', 
          depend: () => this.findingDatas[index].finding_code === 'D', 
          required: () => true, 
          readonly: this.findingDatas[index].lesion_type === '' ? false : true, 
          rules: [v => !!v || '必填'] 
        },
        { key: '22i', label: '診斷-腫瘤且為疑似惡性腫瘤', type: 'select', options: lesionD1Options, column: 'lesion_subtype', depend: () => this.findingDatas[index].finding_code === 'D' && this.findingDatas[index].lesion_type === '1', required: () => true, rules: [v => !!v || '必填'] },
        { key: '22j', label: '診斷-腫瘤且為其他腫瘤', type: 'select', options: lesionD2Options, column: 'lesion_subtype', depend: () => this.findingDatas[index].finding_code === 'D' && this.findingDatas[index].lesion_type === '2', required: () => true, rules: [v => !!v || '必填'] },
        { key: '22k', label: '診斷-發炎/潰瘍', type: 'select', 
          options: lesionEOptions, column: 'lesion_type', 
          depend: () => this.findingDatas[index].finding_code === 'E', 
          required: () => true, 
          readonly: this.findingDatas[index].lesion_type === '' ? false : true, 
          rules: [v => !!v || '必填'] 
        },
        { key: '22l', label: '診斷-其他異常', type: 'select', options: lesionFOptions, 
          column: 'lesion_type', 
          depend: () => this.findingDatas[index].finding_code === 'F', 
          required: () => true, 
          readonly: this.findingDatas[index].lesion_type === '' ? false : true, 
          rules: [v => !!v || '必填'] 
        },
        { key: '22m', label: '診斷-其他診斷', type: 'text', column: 'lesion_type', 
          depend: () => this.findingDatas[index].finding_code === 'G' , 
          required: () => true
        },
        { key: '22n', label: '病灶：位置', 
          type: 'select', 
          options: locationOptions, 
          column: 'location', 
          multiple: true,
          readonly: true, 
          rules: [],
          checkC2C3D1: true,
          ruleConfig: {
            dataType: 'array',
            errorText: '必填',
            exceptionFindingIds: [],
            limitLength: 1
          }
        },
        { key: '22o', label: '病灶：位置不明(與肛門口距離)', type: 'input', column: 'location1', dataType: "number", min: 0, max: 200, readonly: true },
        { key: '22p', label: '病灶：處置(可複選)', 
          type: 'select', 
          options: samplingOptions, 
          column: 'sampling',
          multiple: true,
          rules: [],
          readonly: true,
          checkC2C3D1: true,
          ruleConfig: {
            dataType: 'array',
            errorText: '必填',
            exceptionFindingIds: ['40','643'],
            limitLength: 0
          }
        },
        { key: '22q', label: '病灶：處置(Others)其他處置', type: 'input', column: 'sampling1', 
          required: () => this.findingDatas[index].sampling.join('') === '99', 
          depend: () => this.findingDatas[index].sampling.join('') === '99', 
          readonly: true, 
          rules: [],
          dynamicRules: (data) => {
            if(data.sampling.join('') === '99'){
              return [
                v => !!v || '必填'
              ]
            }
            return []
          }
        },
        { key: '22r', label: '病灶：未處置原因(可複選)', multiple: true, type: 'select', 
          options: samrOptions, column: 'samr', 
          depend: () => this.findingDatas[index].sampling.join('') === '00',
          readonly: true,
          rules: [],
          checkC2C3D1: true,
          ruleConfig: {
            dataType: 'array',
            errorText: '必填',
            limitLength: 0
          }
        },
        { key: '22s', label: '病灶：未處置原因-其他', type: 'input', column: 'samr1', 
          depend: () => this.findingDatas[index].samr.join('').includes('z') && this.findingDatas[index].sampling.join('') === '00', 
          rules: [],
          dynamicRules: (data) => {
            if(data.samr.join('').includes('z')){
              return [
                v => !!v || '必填'
              ]
            }
            return []
          }
        },
        { key: '22t', label: '病灶：有無檢體', type: 'select', options: polypOptions, column: 'polyp',required: (data) => {
            return (data.finding_code === 'C' && data.lesion_type !== '1') || data.finding_code === 'D'
          },
          readonly: true,
          rules: this.findingDatas[index].finding_code !== 'A' ? [v => !!v || '必填'] : []
        },
        { key: '22u', label: '病灶：檢體大小', type: 'input', column: 'size', 
          required: (data)=> data.polyp === '1',
          rules: this.findingDatas[index].polyp === '1' ? [v => !!v || '必填'] : [
            v=> v.length === 0 || '無檢體時，Size不可有值'
          ]
        },
        { key: '22v', label: '病灶：檢體編號', type: 'input', column: 'list_value', rules: this.findingDatas[index].polyp === '1' ? [v => !!String(v).match(/^[a-zA-Z]$/) || '編號必須為英文字母'] : [] },
      ])
    },
    async initialSectio3Data(){
      // console.log('this.ishareData', this.ishareData)
      let lesionType = ''
      let lesionSubType = ''
      if(!this.ishareData.findings_data){
        this.findingDatas = handleIshareLesionData(null, this.findings, false, this.ishareData.LesionA)
        this.addSection3Data(0)
        return Promise.resolve(true)
      }
      this.findingDatas = handleIshareLesionData(this.ishareData.findings_data,this.findings, false, this.ishareData.LesionA)
      for(let index = 0; index < this.findingDatas.length; index++){
        this.addSection3Data(index)
      }
      // console.log('this.findingDatas', this.findingDatas)
      return Promise.resolve(true)
    },
    importDbData(){
      const { detail, lesion } = importIshareDataFromDB(this.dbIshareData)
      this.formDetail = detail
      this.findingDatas = this.findingDatas.map((item, idx)=> {
        return {
          ...item,
          ...lesion[idx]
        }
      })
      this.detailId = detail.detail_id
    },
    async onSave(event) {
      console.log('onsave')
      event.preventDefault()
      if (!this.$refs.form.validate()) {
        this.$store.dispatch('snackBar/trigger', {
          message: '請檢查表單填寫是否正確',
          color: 'error', // 或 error/info/warning
          timeout: 3000
        })
        return
      }
      const body = {
        detail: {
          ...this.formDetail,
          indication1: this.formDetail['indication1'].join(''),
          premedication2b: this.formDetail['premedication2b'].join(''),
          colon_preparation: this.formDetail['colon_preparation'].join(''),
          anti_platelet1: this.formDetail['anti_platelet1'].join(''),
          Complication: this.formDetail['Complication'].join(''),
        },
        lesion: this.findingDatas.map(item=> (
          {
            ...item,
            location: item.location.join(''),
            sampling: item.sampling.join(''),
            samr: item.samr.join(''),
          }
        ))
      }
      console.log('save ishare body',md5(JSON.stringify(body)), body)
      const result = await saveIshareData(body.detail, body.lesion, this.detailId, md5(JSON.stringify(body)))
      console.log('儲存內容:', this.formDetail, this.findingDatas, this.detailId);
      // 可送出表單或 emit event
      console.log('result', result)
      if(result){
        this.detailId = result
      }
      this.$store.dispatch('snackBar/trigger', {
        message: '儲存成功',
        color: 'success', // 或 error/info/warning
        timeout: 3000
      })
      setTimeout(() => {
        this.$emit('checkFinish', result)  
      }, 500);
      
    },
    checkIndication(value) {
      if (value !== '2' && value !=='1') {
        return '9'
      }
      return value
    }
  },
};

</script>
<style>
.scrollable-tabs .v-tabs__wrapper {
  overflow-x: auto;
}
</style>